import styled from 'styled-components'
import React from 'react'
import leaf from "../ASSESTS/Food/leaf.png"


interface Iprops {
  image : string;
  title : string;
  price : string
}

const Card:React.FC<Iprops> = ({image , title , price}) => {
  return (
    <div>
        <CardHold>
<Top>
<img src={leaf} alt="" />
</Top>

<ImgHold>
<Img src={image}/>
</ImgHold>
<TextHold>
    <p>{title} </p>
    <h2> ₦{price} </h2>
</TextHold>
<Button>
    Add To Cart
</Button>
        </CardHold>
    </div>
  )
}

export default Card



const Button = styled.button`
width: 150px;
height: 50px;
border-radius: 30px;
background-color: white;
color: green;
cursor: pointer;
border: none;
outline: none;
border: 0.5px solid green;
:hover{
background-color: green;
color: white;
}
`

const TextHold = styled.div``

const Img =styled.img`
width: 180px;
height: 180px;
z-index: 999;

`

const ImgHold = styled.div`
margin-top: 10px;

`

const CardHold = styled.div`
    width: 280px;
    height: 350px;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
    border-radius: 10px;
    margin: 20px;
    background-color: white;
  padding-bottom: 80px;


  

`

const Top = styled.div`
    width: 100%;
    height: 50px;
    position: relative;
    display: flex;
    
  
 img{
    position: absolute;
    top: 0;
right: 0;
    width: 100px;
    height: 100%;
    object-fit: cover;
 }
`